export default __webpack_public_path__ + "static/media/avatar.0d14c699.png";